import {
    APIType,
    TranslationCustomizationFile,
    UserCustomization,
} from '~/backend/types';
import { useImageTranslation } from '~/hooks/workflows/backend/tasks/useImageTranslation';
import {
    useBackendModels,
    useModelCustomizations,
} from '~/hooks/workflows/backend/useBackend';
import ImageTranslation from './ImageTranslation';

export default function ImageTranslationBackendWorkflow() {
    const { startProcessing, isSubmitting } = useImageTranslation();
    const {
        data: availableModels = [],
        isLoading: isLoadingModels,
        error,
    } = useBackendModels(APIType.TRANSLATION);
    const {
        data: modelCustomizations = [],
        isLoading: isLoadingCustomizations,
    } = useModelCustomizations(APIType.TRANSLATION);

    return (
        <ImageTranslation
            modelCustomizations={
                modelCustomizations as UserCustomization<TranslationCustomizationFile>[]
            }
            availableModels={availableModels}
            onSubmit={startProcessing}
            isLoadingModels={isLoadingModels || isLoadingCustomizations}
            isSubmitting={isSubmitting}
            error={error}
            showPseudonymization={true}
        />
    );
}
